var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "edit-mode-selector d-inline-block" },
    [
      _c(
        "b-dropdown",
        {
          attrs: {
            variant: _vm.dropdownVariant,
            disabled: _vm.isClassifying,
            "menu-class": "edit-mode-dropdown-menu",
            right: "",
            "no-flip": "",
            "toggle-class": "edit-mode-toggle-btn",
          },
          on: { shown: _vm.onDropdownShown, hidden: _vm.onDropdownHidden },
          scopedSlots: _vm._u([
            {
              key: "button-content",
              fn: function () {
                return [
                  _vm.isClassifying
                    ? _c("b-spinner", {
                        staticClass: "mr-2",
                        attrs: { small: "" },
                      })
                    : _c("b-icon", {
                        staticClass: "mr-2",
                        attrs: { icon: _vm.currentModeIcon },
                      }),
                  _vm._v(
                    "\n      " + _vm._s(_vm.currentModeLabel) + "\n      "
                  ),
                  _c("b-icon", {
                    staticClass: "ml-2 dropdown-caret",
                    attrs: { icon: "chevron-down", "font-scale": "0.8" },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _vm._l(_vm.editModes, function (mode) {
            return _c(
              "b-dropdown-item",
              {
                key: mode.value,
                attrs: { active: _vm.currentMode === mode.value },
                on: {
                  click: function ($event) {
                    return _vm.changeMode(mode.value)
                  },
                },
              },
              [
                _c("b-icon", {
                  staticClass: "mr-2",
                  attrs: { icon: mode.icon },
                }),
                _vm._v("\n      " + _vm._s(mode.label) + "\n      "),
                mode.description
                  ? _c(
                      "small",
                      {
                        staticClass: "d-block edit-mode-description",
                        class: {
                          "description-active": _vm.currentMode === mode.value,
                        },
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(mode.description) + "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }